import { createMuiTheme as createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#538fff',
      light: 'rgba(83,143,255, 0.1)',
      dark: '#3481f6',
      shadow: 'rgba(76,147,255, 0.4)',
    },
    secondary: {
      main: '#ff8181',
    },
    grey: {
      900: '#e4e7eb',
      600: '#e4e7eb',
    },
    bodyBG: '#F1F6FF',
    font: {
      main: '#2e4469',
      sub: '#7d86a9',
      white: '#ffffff',
      grey: '#dddddd',
      blue: 'rgba(83,143,255, 0.6)',
    },
    staff: {
      blue: '#7adbef',
      red: '#ff8187',
      purple: '#979bff',
      green: '#6be5b7',
      yellow: '#ffc95c',
    },
    status: {
      blue: '#00a8f9',
      red: '#ff655c',
      purple: '#7b80ff',
      green: '#28d2ab',
      yellow: '#fcb836',
      grey: '#bec3d4',
      greyBg: '#e1e8ee',
    },
    inputBorder: {
      gray: '#e4e7eb',
    },
  },
  typography: {
    fontFamily: ['NotoSans-Bold', 'NotoSans-Medium'].join(','),
  },
  overrides: {
    MuiCssBaseline: {},
  },
});

export default theme;
